import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api, setSessionToken } from "../lib/api";
import { useAuth } from "../lib/auth";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");

    if (!sessionId) {
      navigate("/");
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        // Persist token in localStorage as cookie-fallback (Safari ITP, PWAs).
        if (data?.session_token) setSessionToken(data.session_token);
        setUser(data);
        // clean hash
        window.history.replaceState(null, "", window.location.pathname);
        // Resume any deep link that the user originally tried (Share Target,
        // PWA shortcut, etc.) — stashed by ProtectedRoute before login.
        let next = "/app";
        try {
          const stashed = sessionStorage.getItem("mise_post_login_redirect");
          if (stashed && stashed.startsWith("/app")) {
            next = stashed;
            sessionStorage.removeItem("mise_post_login_redirect");
          }
        } catch {}
        navigate(next, { replace: true, state: { user: data } });
      } catch (e) {
        console.error("Auth callback failed", e);
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center" data-testid="auth-callback-loading">
        <div className="flex justify-center gap-2 mb-6">
          <span className="w-3 h-3 rounded-full bg-[hsl(var(--primary))] simmer" />
          <span className="w-3 h-3 rounded-full bg-[hsl(var(--secondary))] simmer-2" />
          <span className="w-3 h-3 rounded-full bg-[hsl(var(--primary))] simmer-3" />
        </div>
        <p className="font-serif italic text-2xl text-[hsl(var(--foreground))]">Encendiendo los fogones…</p>
      </div>
    </div>
  );
}
